import React, { useState, useEffect, useRef } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { compose } from 'redux'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'
import { withStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { Helmet } from 'react-helmet'
import Slider from 'react-slick'
import { useFirestoreConnect, isEmpty, isLoaded, useFirebase } from 'react-redux-firebase'
import Header2 from '../Header2'
import Footer from '../Footer'
import SearchResults from '../SearchResults'
import TabHeader from '../TabHeader'
import Type from '../Type'
import IconChevronLeft from '../../Icons/IconChevronLeft'
import IconChevronRight from '../../Icons/IconChevronRight'
import Close from '../../Icons/IconMXClose'
import LogoSimple from '../../Icons/IconLogoSimple'
import L from '../L'
import {
  WEBSITE_CONFIG_COLLECTION,
  WEBSITE_CONFIG_ID,
  COLLECTIONS_COLLECTION,
  SIMULATIONS_COLLECTION,
} from '../../Config'
import IconFDXLogoSimple from '../../Images/IconFDXLogoSimple.png'
import { useEventListener } from '../../Utils/hooks'
import AccountActions from '../../Redux/AccountRedux'
import { MainContainer, SlickDot, SlickArrow, CenteringDiv, layoutStyles } from './Layout-styles'
import iconBufferingGrey from '../../Images/icon_buffering_grey.svg'

const UPDATES = []

// TODO Repurpose UpdatePopup Component
// Link to clickup story: https://app.clickup.com/t/1qvhgpq
// eslint-disable-next-line no-unused-vars
const UpdatePopup = props => {
  const [gifRefresh, setGifRefresh] = useState('')
  const sliderRef = useRef(null)
  const [activeIndex, setActiveIndex] = useState(-1)
  const firebase = useFirebase()
  const profile = useSelector(({ firebase }) => firebase.profile)
  const THIS_RELEASE_NOTES = '02.05.01'
  const handleClose = () => {
    const uid = firebase.auth().currentUser && firebase.auth().currentUser.uid
    try {
      firebase
        .firestore()
        .collection('users')
        .doc(uid)
        .update({ lastpopupversion: THIS_RELEASE_NOTES })
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log('error setting user profile')
    }
    props.onClose()
  }
  const renderDots = () => {
    const dots = []
    UPDATES.map((updates, idx) => {
      dots.push(
        <SlickDot
          key={`slick-dot_${idx}`}
          active={activeIndex === idx}
          onMouseUp={() => sliderRef.current.slickGoTo(idx)}
        />,
      )
    })
    dots.push(
      <SlickDot
        key="slick-dot_finished"
        active={activeIndex === UPDATES.length}
        onMouseUp={() => sliderRef.current.slickGoTo(UPDATES.length)}
      />,
    )
    return dots
  }
  useEffect(() => {
    setGifRefresh(Math.random().toString() + activeIndex)
  }, [activeIndex])
  // user is not logged in, or profile is not loaded
  if (profile.isEmpty || !profile.isLoaded) return null
  // no need to display
  if (profile.lastpopupversion === THIS_RELEASE_NOTES) return null

  return (
    <Dialog className="round center" open={props.open}>
      <L pY={2.5} pX={2} maxX="360px">
        <L display="grid" jc="flex-end" mB={1.5} onMouseUp={handleClose} selectable>
          <Close height="20" width="20" />
        </L>
        <L display="grid" gap={2} overflowX="hidden">
          <L minX="1px" maxX="100%">
            {activeIndex === -1 ? (
              <L display="grid" gap={3}>
                <L display="grid" ji="center" ac="center" gap={3} width="100%" height="210px">
                  <LogoSimple height="50" width="50" />
                  <Type variant="headerMedium" textAlign="center">
                    We've added more magic to your IdeaCloud
                  </Type>
                </L>
                <L display="grid" gap={2} jc="center">
                  <Button className="uppercase" color="primary" variant="contained" onMouseUp={() => setActiveIndex(0)}>
                    See what's new
                  </Button>
                  <L
                    display="grid"
                    flow="column"
                    gap={0.5}
                    ai="center"
                    jc="center"
                    color="tertiaryLight"
                    selectable
                    onMouseUp={handleClose}
                  >
                    <Close height="16" width="16" />
                    <Type variant="h6" decoration="underline">
                      Dismiss
                    </Type>
                  </L>
                </L>
              </L>
            ) : (
              <>
                <Slider
                  ref={sliderRef}
                  slidesToShow={1}
                  slidesToScroll={1}
                  speed={500}
                  infinite={false}
                  swipeToSlide
                  arrows={false}
                  beforeChange={(oldIndex, newIndex) => setActiveIndex(newIndex)}
                >
                  {UPDATES.map((update, idx) => (
                    <div key={`update_${idx}`}>
                      <L display="grid" gap={3}>
                        <L
                          width="100%"
                          height="210px"
                          bgImg={`${update.src}?${gifRefresh}`}
                          style={{ backgroundSize: 'contain' }}
                        />
                        <Type variant="subtitle" textAlign="center">
                          {update.description}
                        </Type>
                      </L>
                    </div>
                  ))}
                  <div>
                    <L display="grid" ac="center" gap={3}>
                      <L display="grid" ji="center" ac="center" gap={3} width="100%" height="210px">
                        <LogoSimple height="50" width="50" />
                        <Type variant="headerMedium" textAlign="center">
                          You're all caught up
                        </Type>
                      </L>
                      <Type variant="subtitle" textAlign="center">
                        Read more details about these updates in our
                        <a href="https://www.forgedx.com/releases/02-05-release-notes" target="_blank" rel="noreferrer">
                          <span style={{ textDecoration: 'underline', color: '#0852D7' }}> release notes</span>
                        </a>
                      </Type>
                    </L>
                  </div>
                </Slider>
                <L display="grid" gap={2.5} flow="column" jc="center" ai="center" pT={1.5}>
                  <SlickArrow hide={activeIndex === 0} onMouseUp={() => sliderRef.current.slickPrev()}>
                    <IconChevronLeft />
                  </SlickArrow>
                  <L display="grid" gap={1} flow="column">
                    {renderDots()}
                  </L>
                  <SlickArrow hide={activeIndex === UPDATES.length} onMouseUp={() => sliderRef.current.slickNext()}>
                    <IconChevronRight />
                  </SlickArrow>
                </L>
              </>
            )}
          </L>
        </L>
      </L>
    </Dialog>
  )
}

const enhance = compose(withRouter, withStyles(layoutStyles))

const Layout = ({
  autohide,
  hide,
  staticHeader,
  hideSecondaryHeader,
  classes,
  full,
  narrow,
  paddingX,
  fixHeight,
  backgroundColor,
  headerRightContent,
  tabs = [],
  tab,
  paths = [],
  noFirestoreConnect,
  title,
  noFooter,
  onClick,
  onMouseUp,
  onMouseDown,
  theme,
  match,
  ...props
}) => {
  const firestore = useSelector(({ firestore }) => firestore) || {}
  const { data, ordered } = firestore
  const collections = ordered?.[COLLECTIONS_COLLECTION]
  const simulations = data?.[SIMULATIONS_COLLECTION]
  const config = firestore?.data?.[WEBSITE_CONFIG_COLLECTION]?.[WEBSITE_CONFIG_ID]
  const account = useSelector(({ account }) => account) || {}
  const { searchItems } = account
  const dispatch = useDispatch()

  const [appBarShowing, setAppBarShowing] = useState(false)
  const [appBarExpanded, setAppBarExpanded] = useState(false)
  const allowOutline = useSelector(() => account.allowOutline)

  useFirestoreConnect(
    noFirestoreConnect
      ? []
      : [
          {
            collection: WEBSITE_CONFIG_COLLECTION,
            where: ['id', '==', WEBSITE_CONFIG_ID],
          },
          {
            // Load ALL Colletions
            collection: COLLECTIONS_COLLECTION,
            orderBy: ['weight'],
          },
          {
            // Load ALL Simulations
            collection: SIMULATIONS_COLLECTION,
          },
        ],
  )

  useEventListener('keydown', e => {
    if (e.keyCode === 9) dispatch(AccountActions.AccountAllowOutline(true))
  })

  const handleMouseEnter = () => setAppBarShowing(true)

  const handleMouseLeave = () => {
    setAppBarShowing(false)
    setAppBarExpanded(false)
  }
  const handleClickOutside = e => {
    setAppBarShowing(false)
    setAppBarExpanded(false)
    if (onClick) onClick(e)
  }

  const renderBreadcrumbs = () => {
    let type
    const collection = match.params?.collection
    let showBreadcrumbs = false
    const breadcrumbs = []

    if (collections) {
      switch (collections[collection] && collections[collection].type) {
        case 'vertical':
          type = 'vertical'
          type = 'verticals'
          break
        case 'event':
          type = 'event'
          type = 'events'
          break
        default:
          type = ''
      }
    }

    breadcrumbs.push(
      <Link key="breadcrumb_type_link" to="/" className={classes.breadcrumbLink}>
        {config && config.name}
      </Link>,
    )
    breadcrumbs.push(<span key="breadcrumb_type_seperator"> | </span>)
    showBreadcrumbs = true
    if (type) {
      breadcrumbs.push(
        <Link key="breadcrumb_vertical_link" to={`/${type}/#${collection}`} className={classes.breadcrumbLink}>
          {collections[collection].name}
        </Link>,
      )
      breadcrumbs.push(<span key="breadcrumb_vertical_seperator"> | </span>)
      showBreadcrumbs = true
    }

    if (paths) {
      for (let i = 0; i < paths.length; i++) {
        breadcrumbs.push(
          <Link key={`breadcrumb_${i}`} to={paths[i].to} className={classes.breadcrumbLink}>
            {paths[i].name}
          </Link>,
        )
        breadcrumbs.push(<span key={`breadcrumb_vertical_seperator_${i}`}> | </span>)
      }
    }

    if (title) {
      breadcrumbs.push(
        <span key="breadcrumb_layout_title" className={classes.breadcrumbLinkCurrent}>
          {title}
        </span>,
      )
    } else {
      // Remove Last seperator
      breadcrumbs.pop()
    }
    return showBreadcrumbs ? breadcrumbs : []
  }

  if (!isLoaded(config, simulations, collections)) {
    return (
      <L display="grid" ai="center" jc="center" position="fixed" t="0" b="0" l="0" r="0" mXAuto mYAuto>
        <CenteringDiv>
          <img
            src={iconBufferingGrey}
            alt=""
            style={{ fill: '#808080', marginBottom: '10px', animation: 'rotate 1.5s infinite linear' }}
          />
        </CenteringDiv>
      </L>
    )
  }

  if (isEmpty(config, simulations)) return <div>Error</div>

  const appBarMargin = autohide ? (appBarShowing ? 0 : -35) : 0
  const appBarOpacity = autohide ? (appBarShowing ? 1 : 0) : 1

  const $header = document.querySelector('header')
  const $footer = document.querySelector('footer')

  const headerHeight = ($header && $header.offsetHeight) || 0
  const footerHeight = $footer && !noFooter ? $footer.offsetHeight : 0

  const controlPanelHeight = `calc(100vh - ${headerHeight + footerHeight}px)`

  const mainContainer = {
    maxWidth: full ? '100%' : narrow ? 1010 : 1340,
    paddingLeft: paddingX || 0,
    paddingRight: paddingX || 0,
    height: fixHeight ? controlPanelHeight : 'auto',
    overflow: fixHeight ? 'hidden' : '',
    backgroundColor: backgroundColor || '#FFFFFF',
  }
  const bodyContainer = {
    backgroundColor: theme && theme === 'light' && '#F9F9F9',
  }

  return (
    <Grid container className={classes.root} direction="column" justify="space-between" style={bodyContainer}>
      {config?.favicon?.signedUrl && (
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="icon" type="image/png" sizes="16x16" href={config.favicon.signedUrl} />
        </Helmet>
      )}

      {!hideSecondaryHeader && (
        <div className={!staticHeader ? classes.secondaryHeaderBoxShadow : null}>
          <Header2
            backgroundImage={config?.header?.backgroundImage?.signedUrl}
            logo={config?.header?.logo?.signedUrl}
            title={config?.header?.text}
          />
        </div>
      )}

      {!hide && (
        <div
          tabIndex="-1"
          aria-hidden="true"
          className={autohide ? classes.appBarWrapperAutohide : classes.appBarWrapper}
          onMouseEnter={handleMouseEnter}
        >
          <AppBar
            position={appBarExpanded || staticHeader ? 'relative' : 'fixed'}
            color="default"
            className={[classes.appBar, autohide ? 'autohide' : ''].join(' ')}
            style={{
              top: appBarMargin,
              opacity: appBarOpacity,
              transition: 'top .2s ease-in-out, opacity .2s ease-in-out',
            }}
            onMouseLeave={handleMouseLeave}
          >
            {!appBarExpanded && (
              <Toolbar>
                <a href="/" className={classes.fdxLogo}>
                  <img src={IconFDXLogoSimple} alt="ForgeDX Logo" />
                </a>
                <Typography variant="body2" color="inherit" className={classes.l_breadcrumbs}>
                  {renderBreadcrumbs()}
                </Typography>
                {headerRightContent || null}
              </Toolbar>
            )}
          </AppBar>
        </div>
      )}
      {!!tabs.length && <TabHeader tabs={tabs} tab={tab} />}
      <MainContainer
        allowOutline={allowOutline}
        style={mainContainer}
        onClick={handleClickOutside}
        onMouseUp={e => {
          if (onMouseUp) onMouseUp(e)
        }}
        onMouseDown={e => {
          if (onMouseDown) onMouseDown(e)
        }}
      >
        {searchItems.length ? <SearchResults /> : props.children}
      </MainContainer>
      {!noFooter && <Footer />}
      {/* TODO this code is also part of the todo code above for UpdatePopup component  
        {!window.location.href.includes('/public') && (
        <UpdatePopup
          open={updatePopupOpen}
          onClose={() => setUpdatePopupOpen(false)}
        />
      )} */}
    </Grid>
  )
}

Layout.propTypes = {}

Layout.defaultProps = {
  theme: 'light',
}

export default enhance(Layout)
